import DapDSScrollProgress from './scroll-progress.component'

export * from './scroll-progress.component'
export default DapDSScrollProgress

DapDSScrollProgress.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-scroll-progress': DapDSScrollProgress
  }
}
